import React, { FC, memo } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {
  text: string
  count: number | null
  className?: string
}

export const ProjectStatusItem: FC<Props> = memo(({ text, count, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-items-center">
        <Txt>{text}</Txt>
        <Txt>:</Txt>
        {/* デフォルトフォントとアルファベット向けフォントの高さの差異を吸収するためpaddingで調整 */}
        <Txt fontType="alphabet" className="tw-pt-[0.14em]">
          {count ?? '-'}
        </Txt>
      </div>
    </div>
  )
})
